export const JOBS_LIST_URL_KEY = 'jobs-list-url';
